import { Component, OnInit } from '@angular/core';
import { AccountService } from 'src/app/core/services/auth/account.service';

@Component({
  selector: 'app-guest-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss']
})
export class MainGuestComponent implements OnInit {

  constructor(private accountService:AccountService) { }

  ngOnInit(): void {
    
    // this.loadUserProfile();
  }
  async loadUserProfile() {
    await this.accountService.loadUserProfile();
  }
}
